var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDocumentinline = function SvgDocumentinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 0v24h18.462V6.087l-.26-.289L15.663.26 15.376 0H3Zm1.846 1.846h9.23v5.539h5.54v14.769H4.845V1.846Zm11.077 1.327 2.365 2.365h-2.365V3.173ZM7.615 9.231v1.846h9.231V9.23h-9.23Zm0 3.692v1.846h9.231v-1.846h-9.23Zm0 3.692v1.847h9.231v-1.847h-9.23Z"
  })));
};

export default SvgDocumentinline;